import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { MEDIA } from "../data";
import { useLang } from "../LanguageContext";

export const About = () => {
  const { t } = useLang();
  return (
    <section id="o-nas" className="bg-[#0A0A0A] py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div>
          <p className="font-body text-xs font-bold uppercase tracking-[0.22em] text-[#E02020] mb-4">{t.about.overline}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            {t.about.title}
          </h2>
          <p className="mt-5 text-[#A3A3A3] leading-relaxed">{t.about.paragraph}</p>

          <ul className="mt-7 space-y-3">
            {t.about.points.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm sm:text-base text-white/85">
                <CheckCircle2 className="text-[#E02020] shrink-0 mt-0.5" size={20} />
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-white/10 pt-8">
            {t.about.stats.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`stat-${i}`}
              >
                <div className="font-display text-2xl sm:text-3xl font-bold text-white leading-none">{s.value}</div>
                <div className="mt-2 text-xs text-[#A3A3A3] leading-snug">{s.label}</div>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="aspect-[3/4] sm:aspect-[4/5] overflow-hidden rounded-sm border border-white/10">
            <img src={MEDIA.about} alt="Bezpieczne latanie dronem" className="w-full h-full object-cover" loading="lazy" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
